import React, { useEffect, useState } from 'react';
import { ChannelInfoForm } from '../../components';
import { loaderGIF } from '../../rootAccess';
import './CreateChannelForm.scss';
import { handleCreateChannel } from '../../utils';

function CreateChannel() {
   const [isActionPending, setIsActionPending] = useState(false);
   const [channel, setChannel] = useState({
      channelName: '',
      description: 'A channel is a dedicated space for focused conversations and content sharing. Users can create channels to organize discussions, collaborate on specific topics, and keep everyone informed and engaged within a streamlined environment',
      imageUri: '',
      profileThumb: '',
      categoryId: '',
      settings: {
         accessMode: 1, // 1 - public, 2 - private
         messageMode: 4, //can message 1 - All, 4 - Admin only
      },
   });


   const handleSubmit = async submitObbject => {
      setIsActionPending(true);
      await handleCreateChannel(submitObbject);
      setIsActionPending(false);
   };

   const handleToggleChange = newSettings => {
      setChannel(prev => ({
         ...prev,
         settings: {
            accessMode: newSettings.accessMode,
            messageMode: newSettings.messageMode,
         },
      }));
   };

   return (
      <>
         {isActionPending && (
            <div
               style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(255,255,255,0.6)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 10,
               }}>
               <img src={loaderGIF} alt="Loading..." style={{ width: '50px', height: '50px' }} />
            </div>
         )}

         <ChannelInfoForm
            data={channel}
            onChange={setChannel}
            onSubmit={handleSubmit}
            showSubmit
            showToggles
            settings={{
               accessMode: channel.settings.accessMode,
               messageMode: channel.settings.messageMode,
            }}
            onToggleChange={handleToggleChange}
         />
      </>
   );
}

export default CreateChannel;
